import { render, staticRenderFns } from "./InsuranceRiskPaymentForm.vue?vue&type=template&id=234a5a9f&"
import script from "./InsuranceRiskPaymentForm.vue?vue&type=script&lang=js&"
export * from "./InsuranceRiskPaymentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports